import { ExclamationTriangleFill } from "react-bootstrap-icons";
import styles from "./ReviewClientTasksLockedBanner.module.scss";

type ReviewClientTasksLockedBannerProps = {
  width: string;
};

export default function ReviewClientTasksLockedBanner(
  props: ReviewClientTasksLockedBannerProps,
) {
  return (
    <div
      className={styles.warningBox}
      style={{ width: props.width }}
      data-testid="review-client-tasks-locked-banner"
    >
      <ExclamationTriangleFill className="me-2" color="#CEA552" />
      Client response in progress, editing disabled.
    </div>
  );
}
